module.exports = __webpack_public_path__ + "media/6_5.846fdd65.wav";